import React, { useState } from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import type { SupportedLanguage } from '../types';
import { TranslationKey } from '../i18n/translations';
import { ConfirmationModal } from './ConfirmationModal';
import { v4 as uuid } from 'uuid'; // Import uuid for generating new session IDs

interface NewConversationButtonProps {
  onNewConversation: (sessionId: string) => void;
  getTranslation: (key: TranslationKey, lang?: SupportedLanguage) => string;
  interfaceLanguage: SupportedLanguage;
}

export const NewConversationButton: React.FC<NewConversationButtonProps> = ({
  onNewConversation,
  getTranslation,
  interfaceLanguage,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handlePress = () => {
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    setShowConfirmation(false);
    const newSessionId = uuid(); // Generate a new session ID
    onNewConversation(newSessionId); // Pass the new session ID to the callback
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  return (
    <>
      <TouchableOpacity style={styles.newConversationButton} onPress={handlePress}>
        <Text style={styles.newConversationButtonText}>
          {getTranslation('startNewConversationButton', interfaceLanguage)}
        </Text>
      </TouchableOpacity>

      <ConfirmationModal
        visible={showConfirmation}
        title={getTranslation('confirmationModal.title', interfaceLanguage)}
        message={getTranslation('confirmationModal.message', interfaceLanguage)}
        getTranslation={getTranslation}
        interfaceLanguage={interfaceLanguage}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
};

const styles = StyleSheet.create({
  newConversationButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderWidth: 1,
    borderColor: '#ADD8E6',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    alignSelf: 'center',
    marginTop: 16,
  },
  newConversationButtonText: {
    color: '#007AFF',
    fontSize: 14,
    fontWeight: '500',
  },
});